import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
import logo from '../assets/logo.png';
import logo2 from '../assets/logo2.png';
import './CSS/PhoneAuthentication.css'; // Import the CSS file

class PhoneAuthentication2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      phone_number: '', // Updated state key to match schema
      message: '',
      errorMessage: '',
      isSubmitting: false
    };
  }

  handlePhoneNumberChange = (e) => {
    this.setState({ phone_number: e.target.value }); // Updated state key to match schema
  }

  validatePhoneNumber = (phone_number) => { // Updated parameter name to match schema
    // Example validation: ensure the phone number starts with a + and contains only digits
    const phoneRegex = /^\+\d{10,15}$/;
    return phoneRegex.test(phone_number);
  }

  handleSubmit = async (e) => {
    e.preventDefault();
    const { phone_number } = this.state; // Updated state key to match schema

    // Validate phone number before submission
    if (!this.validatePhoneNumber(phone_number)) {
      this.setState({ errorMessage: 'Please enter a valid phone number with a + sign and country code.', message: '', isSubmitting: false });
      return;
    }

    this.setState({ isSubmitting: true });

    try {
      const response = await axios.post('/send-otp-phone', { phone_number }); // Updated request payload key to match schema

      if (response.status === 200) {
        this.setState({ message: 'OTP has been sent to your phone.', errorMessage: '', isSubmitting: false });

        // Wait for 3 seconds before redirecting to the OTP authentication page
        setTimeout(() => {
          // Redirect to the OTP authentication page
          this.props.history.push('/otpauthentication2', { phone_number }); // Updated state key to match schema
        }, 3000);
      } else {
        this.setState({ errorMessage: response.data.message, message: '', isSubmitting: false });
      }
    } catch (error) {
      if (error.response) {
        this.setState({ errorMessage: error.response.data.message, message: '', isSubmitting: false });
      } else {
        this.setState({ errorMessage: "An error occurred. Please try again later.", message: '', isSubmitting: false });
      }
    }
  }

  render() {
    return (
      <div className="phone-container d-flex align-items-center justify-content-center">
        <div className="text-center">
          <img className='logo' src={logo} alt="Logo" />
          <br />
          <h2>Phone Authentication</h2>
          <div className="row justify-content-center">
            <div className="col-sm-8">
              <div className="card">
                <div className="card-body">
                  <form onSubmit={this.handleSubmit}>
                    <div className="form-group">
                      <label htmlFor="phone_number">Enter Phone Number</label> {/* Updated label htmlFor attribute */}
                      <input
                        type="text"
                        className="form-control"
                        name="phone_number" // Updated input name attribute
                        id="phone_number" // Updated input id attribute
                        value={this.state.phone_number} // Updated state key to match schema
                        onChange={this.handlePhoneNumberChange}
                        required
                        placeholder="+1234567890"
                      />
                      <small className="form-text text-muted">
                        Please enter your phone number in international format, starting with + and the country code.
                      </small>
                    </div>
                    <button type="submit" className="btn btn-dark" disabled={this.state.isSubmitting}>
                      {this.state.isSubmitting ? 'Submitting...' : 'Submit Phone Number'}
                    </button>
                  </form>
                  {this.state.message && <div className="alert alert-success mt-3">{this.state.message}</div>}
                  {this.state.errorMessage && <div className="alert alert-danger mt-3">{this.state.errorMessage}</div>}
                  <div className="text-center mt-3">
                    <div>Powered by</div>
                    <img className='logo2' src={logo2} alt="Logo 2" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(PhoneAuthentication2);
